Object.defineProperty(exports, "__esModule", { value: true });
var FieldContext = /** @class */ (function () {
    function FieldContext(fieldOptions) {
        this.fieldOptions = fieldOptions;
    }
    return FieldContext;
}());
exports.FieldContext = FieldContext;
//# sourceMappingURL=FieldContext.js.map